/* istanbul ignore file */
// @todo tymofiih@wix.com research enzyme render issue

import React from 'react';
import {Button, ButtonPriority, HoverStyles} from 'wix-ui-tpa/cssVars';
import {Button as OldButton} from 'wix-ui-tpa';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import BackInStockButtonStyles from './BackInStockButton.scss';
import {classes as backInStockButtonClasses} from './BackInStockButton.st.css';
import classNames from 'classnames';

interface BackInStockButtonInterface extends ProvidedGlobalProps, IProvidedTranslationProps {}

interface BackInStockButtonState {
  showError: boolean;
}

export enum BackInStockButtonDataHook {
  Root = 'BackInStockButton.Root',
}

class BackInStockButtonComponent extends React.Component<BackInStockButtonInterface, BackInStockButtonState> {
  private createNotification() {
    this.props.globals.handleNotifyWhenBackInStock();
  }

  private getClasses() {
    const {shouldShowWishlistButton} = this.props.globals;
    return classNames(BackInStockButtonStyles.backInStockButton, backInStockButtonClasses.backInStockButton, {
      [BackInStockButtonStyles.primaryButton]: shouldShowWishlistButton,
      [BackInStockButtonStyles.fullWidth]: !shouldShowWishlistButton,
    });
  }

  public render() {
    const shouldEnableAddToCartColorContrast = this.props.globals.experiments.addToCartButtonColorContrast;
    return shouldEnableAddToCartColorContrast ? (
      <Button
        data-hook={BackInStockButtonDataHook.Root}
        onClick={() => {
          this.createNotification();
        }}
        className={this.getClasses()}
        hoverStyle={shouldEnableAddToCartColorContrast ? HoverStyles.underline : undefined}
        priority={shouldEnableAddToCartColorContrast ? ButtonPriority.primary : undefined}>
        {this.props.t('productPage.backInStock.notifyWhenAvailable.button')}
      </Button>
    ) : (
      <OldButton
        data-hook={BackInStockButtonDataHook.Root}
        onClick={() => {
          this.createNotification();
        }}
        className={this.getClasses()}>
        {this.props.t('productPage.backInStock.notifyWhenAvailable.button')}
      </OldButton>
    );
  }
}

export const BackInStockButton = withGlobalProps(withTranslations('globals.texts')(BackInStockButtonComponent));
